import { Component, EventEmitter, Output } from '@angular/core';
import { LocalizationPipe } from '@abp/ng.core';

@Component({
  selector: 'app-state-definition-toolbar',
  standalone: true,
  imports: [LocalizationPipe],
  templateUrl: './state-definition-toolbar.component.html',
  styleUrl: './state-definition-toolbar.component.scss',
})
export class StateDefinitionToolbarComponent {
  @Output() addNew = new EventEmitter<void>();
}
